import { forwardRef, type Ref, type SVGProps } from "react";
const IconKeyboardOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M29 6H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1m-1 16H4V8h24Z" />
    <path d="M7 10h2v2H7z" />
    <path d="M11 10h2v2h-2z" />
    <path d="M15 10h2v2h-2z" />
    <path d="M19 10h2v2h-2z" />
    <path d="M23 10h2v2h-2z" />
    <path d="M7 14h2v2H7z" />
    <path d="M11 14h2v2h-2z" />
    <path d="M15 14h2v2h-2z" />
    <path d="M19 14h2v2h-2z" />
    <path d="M23 14h2v2h-2z" />
    <path d="M7 18h2v2H7z" />
    <path d="M11 18h10v2H11z" />
    <path d="M23 18h2v2h-2z" />
  </svg>
);
const ForwardRef = forwardRef(IconKeyboardOutlineSVG);
ForwardRef.displayName = "IconKeyboardOutline";
export { ForwardRef as IconKeyboardOutline };
